import { Trans } from "@lingui/react";
import * as React from 'react';
import { FullScreenDrawer } from '~ui/components/content/Drawer/FullScreenDrawer';
import { Text } from '~ui/components/typography/Text/Text';
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Drawer that renders the guide content.
 * Used on mobile devices.
 */
export var GuideOverlayDrawer = function GuideOverlayDrawer(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      footerContent = _ref.footerContent,
      children = _ref.children;
  return /*#__PURE__*/_jsx(FullScreenDrawer, {
    isOpen: isOpen,
    onClose: onClose,
    headerProps: {
      closeIconSide: "right",
      title: /*#__PURE__*/_jsx(Text, {
        fontStyle: "boldSemi",
        fontSize: "m18",
        children: /*#__PURE__*/_jsx(Trans, {
          id: "QMLQmM"
        })
      })
    },
    containerProps: {
      padding: "none",
      overflow: "hidden"
    },
    footerProps: {
      shadow: "none",
      padding: {
        top: "smallMedium",
        bottom: "medium",
        left: "medium",
        right: "medium"
      },
      content: footerContent
    },
    children: children
  });
};